import gql from 'graphql-tag';

import { MyFavDepartmentsFragment, MyFavIdsFragment } from './fragments/MyFavsFragment';

export const query = gql`
  query MyFavoriteDepartments(
    $showLikes: Boolean = true
    $showEvents: Boolean = false
    $smallEvent: Boolean = false
    $includeRound: Boolean = false
    $roundDetails: Boolean = false
  ) {
    myProfile {
      id
      ...MyFavDepartmentsFragment
    }
  }
  ${MyFavDepartmentsFragment}
`;

export const querySmall = gql`
  query MyFavoriteDepartments {
    myProfile {
      id
      ...MyFavIdsFragment
    }
  }
  ${MyFavIdsFragment}
`;
